import { DatasetsService } from "./../datasets/datasets.service";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { AnonMapService } from "../../shared/models/map-services.model";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit, OnDestroy {
  $onDestroy: Subject<any> = new Subject<any>();
  datasets: AnonMapService[];

  constructor(private datasetsService: DatasetsService) {}

  ngOnInit() {
    this.getDatasets();
  }

  getDatasets(): void {
    this.datasetsService
      .getDatasets()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe((datasets) => (this.datasets = datasets));
  }

  get loading(): boolean {
    return this.datasetsService.datasetsLoading;
  }

  /**
   * @returns void
   */
  scrollToDatasets(): void {
    const target = document.querySelector("#datasetsSlider");
    target.scrollIntoView({
      block: "end",
      inline: "nearest",
      behavior: "smooth",
    });
  }
  ngOnDestroy() {
    this.$onDestroy.next();
    this.$onDestroy.complete();
  }
}
